import { Controller } from "@hotwired/stimulus";
import { formatHours, parseTime, slotMinutes } from "../schedule_helpers";

export default class extends Controller {
  static targets = ["month", "notice", "row", "total"];
  static values = { otherMonths: Array };

  connect() {
    this.refresh();
  }

  addSlot(event) {
    const row = event.currentTarget.closest("tr");
    const sameDay = this.rowsFor(row.dataset.weekday);
    const copy = row.cloneNode(true);
    copy.querySelectorAll("input[type=time]").forEach((input) => (input.value = ""));
    sameDay[sameDay.length - 1].after(copy);
    this.refresh();
  }

  removeSlot(event) {
    const row = event.currentTarget.closest("tr");
    if (this.rowsFor(row.dataset.weekday).length > 1) {
      row.remove();
    } else {
      row.querySelectorAll("input[type=time]").forEach((input) => (input.value = ""));
    }
    this.refresh();
  }

  refresh() {
    let total = 0;
    const labelled = new Set();

    this.rowTargets.forEach((row) => {
      const weekday = row.dataset.weekday;
      row.querySelector("[data-day-label]").classList.toggle("invisible", labelled.has(weekday));
      labelled.add(weekday);

      const minutes = this.rowMinutes(row);
      const cell = row.querySelector("[data-hours]");
      if (minutes === null) {
        const dayIsFree = this.rowsFor(weekday).every((other) => this.rowMinutes(other) === null);
        cell.innerHTML = dayIsFree ? '<span class="text-muted">libre</span>' : "";
      } else if (minutes === 0) {
        cell.innerHTML = '<span class="text-danger">inicio = fin</span>';
      } else {
        total += minutes;
        const overnight = parseTime(this.field(row, "end").value) < parseTime(this.field(row, "start").value);
        cell.innerHTML = formatHours(minutes) + (overnight ? "<sup>+1</sup>" : "");
      }
    });

    this.totalTarget.textContent = `${formatHours(total)} h`;
    this.updateNotice();
  }

  updateNotice() {
    const month = this.monthTarget.value;
    const others = [...this.otherMonthsValue].sort();
    const previous = others.filter((other) => other < month).pop();
    const next = others.find((other) => other > month);
    const messages = [];

    if (month && previous) {
      messages.push(
        `La jornada anterior (desde ${this.formatMonth(previous)}) se cerrará automáticamente en ${this.formatMonth(this.previousMonth(month))}.`
      );
    }
    if (month && next) {
      messages.push(
        `Esta jornada se aplicará hasta ${this.formatMonth(this.previousMonth(next))}, antes de la jornada que empieza en ${this.formatMonth(next)}.`
      );
    }

    this.noticeTarget.innerHTML = messages.join("<br>");
    this.noticeTarget.classList.toggle("d-none", messages.length === 0);
  }

  rowsFor(weekday) {
    return this.rowTargets.filter((row) => row.dataset.weekday === weekday);
  }

  rowMinutes(row) {
    const start = parseTime(this.field(row, "start").value);
    const end = parseTime(this.field(row, "end").value);
    if (start === null || end === null) return null;
    return slotMinutes(start, end);
  }

  field(row, name) {
    return row.querySelector(`[data-field=${name}]`);
  }

  // "2026-09" → "2026-08"
  previousMonth(month) {
    const [year, number] = month.split("-").map(Number);
    const date = new Date(Date.UTC(year, number - 2, 1));
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
  }

  // "2026-09" → "09/2026"
  formatMonth(month) {
    const [year, number] = month.split("-");
    return `${number}/${year}`;
  }
}
